var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright",class:_vm.variant},[_vm._m(0),_c('div',{staticClass:"mt-1 ml-1"},[_vm._v("© "+_vm._s(_vm.year)+" The Payment Option")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help"},[_c('a',{attrs:{"href":"mailto:help@thepaymentoption.com"}},[_c('i',{staticClass:"fas fa-user-headset mr-2"}),_vm._v("Need some help? Contact Us.")])])
}]

export { render, staticRenderFns }